module.exports = __webpack_public_path__ + "img/ico-kategoriler.9c83ef84.svg";